<template>
  <div class="student-form-container">
    <!-- 搜索和添加按钮组 -->
    <div class="input-button-group">
      <el-input placeholder="请输入作品名称" style="width: 200px;" v-model="$store.state.name"></el-input>
      <el-button @click="handleSearch" class="add-button" type="primary">搜索</el-button>
       <el-button @click="deletedata" class="add-button" type="primary" v-if="identity==='admin'">批量删除</el-button>
      <!-- <el-button type="primary" class="add-button" @click="dialogFormVisible(true)">添加</el-button> -->
    </div>
  </div>
</template>

<style scoped>
.input-button-group {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}


.add-button {
    background-color: #ff69b4;
    /* 玫红色按钮背景 */
    color: white;
    border: none;
    margin-left: 10px;
    border-radius: 4px;
}

.add-button:hover {
    background-color: #ff1493;
    /* 深玫红色按钮悬停背景 */
}
</style>
<script>
import store from '@/store';
export default {
  data() {
    return {
      name: '',
    };
  },
    computed: {
        identity() {
            return this.$store.state.identity
        }
    },
  methods: {
    
     deletedata(){
        this.$confirm('确定删除选中的作品吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.state.delete=true;
        }).catch(() => {
           
        })},
    handleSearch() {
      let searchValue = this.$store.state.name || '' ; // 统一处理空值为'ALL'
       store.commit('setname', searchValue);
    //  // 新增：直接 emit 搜索事件，传递搜索值
    //   this.$emit('search', searchValue); 
    },
    dialogFormVisible(visible) {
      store.commit('setDialogFormVisible', visible);
    },
  }

}
</script>